
import type { PropType } from 'vue/types/options'

import type { AppMessages } from '../../../../models/i18n/app.messages'
import type { AuditItem } from '../../../../models/services/audit'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'

import { defineComponent, getCurrentInstance } from 'vue'

import { TYPES } from '../../../../config/inversify.types'

import { FeatureIdEnum } from '../../../../enums'
import { capitalizeSentence } from '../../../../filters'

import AuditDetails from '../audit-details.component.vue'

export default defineComponent({
  name: 'PlayboardServiceAuditDetails',
  components: {
    AuditDetails,
  },
  inject: {
    objectIdService: TYPES.ObjectIdService,
  },
  props: {
    audit: {
      type: Object as PropType<AuditItem>,
      required: true,
    },
    ignoredFields: {
      type: Array as PropType<Array<string>>,
      default: () =>
        AuditDetails.props.ignoredFields
          .default()
          .filter((field: string) => field !== 'filters')
          .concat(['imageUrls', 'resultMappings']),
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const ctx = getCurrentInstance()

    const baseClass = 'epb-playboard-service-audit-details'
    const messagesApp = ctx.proxy.$epb.messages.app as AppMessages

    return {
      baseClass,
      messagesApp,
      capitalizeSentence,
      DomainEnum,
      FeatureIdEnum,
    }
  },
  computed: {
    featureList(): any {
      return Object.values(DomainEnum).reduce((_list, domain) => {
        const listFeature = Object.values(FeatureIdEnum).reduce((_listFeature, feature) => {
          return [..._listFeature, [domain, feature]]
        }, [])
        return [..._list, ...listFeature]
      }, [])
    },
  },
  methods: {
    getItemText(item: Record<string, any>): string {
      const itemText = Object.entries(item).map(([key, value]: [string, Record<string, any>]) => {
        return `<strong>${key.toUpperCase()}: </strong> ${
          Array.isArray(value) ? `<br>${this.getValueItemText(value)}` : value
        }`
      })
      return itemText.join('<br>')
    },
    getValueItemText(valueItem: Record<string, any>): string {
      const valueItemText = Object.values(valueItem).map((item: Record<string, any>) => {
        return Object.entries(item).map(([itemKey, itemValue]: [string, string]) => {
          return `&nbsp <strong>${itemKey}: </strong> ${itemValue}`
        })
      })
      return valueItemText.join('<br>')
    },
    getFeatureText: (domain: string, featureId: string, messages: AppMessages): string => {
      const text =
        typeof messages.features[featureId] === 'string'
          ? messages.features[featureId]
          : messages.features[featureId][domain]

      return text ? text.toUpperCase() : ''
    },
  },
})
